import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
//import axios from "axios";

// Utils
import EditDetails from "./EditDetails";
import MyButton from "../../util/MyButton";
import ProfileSkeleton from "../../util/ProfileSkeleton";

// MUI imports
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import MuiLink from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import ToggleButton from "@material-ui/lab/ToggleButton";

// Icons
import CalendarToday from "@material-ui/icons/CalendarToday";
import KeyboardReturn from "@material-ui/icons/KeyboardReturn";
import AddAPhotoIcon from "@material-ui/icons/AddAPhoto";
import CakeIcon from "@material-ui/icons/Cake";
import FitnessCenterIcon from "@material-ui/icons/FitnessCenter";
import AccessibilityNewIcon from "@material-ui/icons/AccessibilityNew";

// Redux
import { connect } from "react-redux";
import { logoutUser, uploadImage, followUser, unfollowUser } from "../../redux/actions/userActions";

/**
 * Profile.js is the page for a logged in user to view
 * their own page and edit details where needed
 */

const styles = (theme) => ({
  ...theme.spreadThis,
});

class Profile extends Component {
  /**
   * Currently following works as such:
   * if you visit someone's profile, then you can click
   * on the follow button and it will send a request
   *
   * TODO: the axios requests should be done via `userActions.js`
   * in the redux
   * TODO: currently if you reload, it will always set the state to false,
   * need to figure out how to get the following info, or just get the previous state
   * TODO: make the follow button look nicer
   */
  // state = {
  //   follow: false,
  // };
  handleImageChange = (event) => {
    const image = event.target.files[0];
    const formData = new FormData();
    formData.append("image", image, image.name);
    this.props.uploadImage(formData);
  };
  handleEditPicture = () => {
    const fileInput = document.getElementById("imageInput");
    fileInput.click();
  };
  handleLogout = () => {
    this.props.logoutUser();
  };

  handleFollow = () => {
    // this.setState({ follow: !this.state.follow });

    const followData = {
      // user: this.props.profile.handle,
      user: this.props.data.currentProfile.user.handle,
    };

    if (this.props.user.following.indexOf(this.props.data.currentProfile.user.handle) === -1) {
      console.log("following user");
      this.props.followUser(followData);
      // axios
      //   .post("/follow", followData)
      //   .then((res) => {          
      //     console.log(res.data);
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
    }
    else {
      console.log("not following user");
      this.props.unfollowUser(followData);
    //   axios
    //     .post("/unfollow", followData)
    //     .then((res) => {
    //       console.log(res.data);
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    }
  };

  // componentDidMount() {    
  //   if (this.props.user.authenticated === true && Object.keys(this.props.data.currentProfile).length !== 0) {
  //     // if (this.props.user.credentials.following) {
  //       if (this.props.user.following) {
  //       // Get list of followers
  //       // const listOfFollowers = this.props.user.credentials.following;
  //       const listOfFollowers = this.props.user.following;
  //       // Check if user is in list
  //       //if (listOfFollowers.indexOf(this.props.profile.handle) === -1)
  //       //console.log(Object.keys(this.props.data.currentProfile).length)
  //       // if (listOfFollowers.indexOf(this.props.data.currentProfile.user.handle) === -1)
  //       //   this.setState({ follow: false });
  //       // else this.setState({ follow: true });
  //     }
  //   }
  // }

  render() {
    const {
      classes,
      // user: { credentials, loading, authenticated },
      UI: { loadingProfile },
      user: { userProfile, authenticated, following },
      //profile,
      data: { currentProfile }
    } = this.props;
    console.log(currentProfile)
    // {console.log(`me: ${handle}`)}
    // {console.log(`other user: ${handle}`)}

    let profileMarkup = loadingProfile || currentProfile === undefined || Object.keys(currentProfile).length === 0 ? (
      <ProfileSkeleton />
    ) : !authenticated ? (
      <Paper className={classes.paper}>
        <Typography variant="body2" align="center">
          No profile found, please login again
        </Typography>
        <div className={classes.buttons}>
          <Button
            variant="contained"
            color="primary"
            component={Link}
            to="/login"
          >
            Login
          </Button>
          <Button
            variant="contained"
            color="secondary"
            component={Link}
            to="/signup"
          >
            Signup
          </Button>
        </div>
      </Paper>
    //) : credentials.handle === profile.handle ? (
      ) : userProfile.handle === currentProfile.user.handle ? (
      <Paper className={classes.paper}>
        <div className={classes.profile}>
          <div className="image-wrapper">
            <img
              // src={credentials.imageUrl}
              src={userProfile.imageUrl}
              alt="profile"
              className="profile-image"
            />
            <input
              type="file"
              id="imageInput"
              hidden="hidden"
              onChange={this.handleImageChange}
            />
            <MyButton
              tip="Edit profile picture"
              onClick={this.handleEditPicture}
              btnClassName="button"
            >
              <AddAPhotoIcon color="primary" />
            </MyButton>
          </div>
          <hr />
          <div className="profile-details">
            <MuiLink
              component={Link}
              //to={`/users/${credentials.handle}`}
              to={`/users/${userProfile.handle}`}
              color="primary"
              variant="h5"
            >
              {/* @{credentials.handle} */}
              @{userProfile.handle}
            </MuiLink>
            <hr />
            {/* {credentials.height && ( */}
              {userProfile.height && (
              <Fragment>
                <AccessibilityNewIcon color="primary" />{" "}
                <span>
                  {/* {parseInt(credentials.height / 12)}'{" "}
                  {parseInt(credentials.height % 12)}" */}
                  {parseInt(userProfile.height / 12)}'{" "}
                  {parseInt(userProfile.height % 12)}"
                </span>
                <hr />
              </Fragment>
            )}
            <hr />
            {/* {credentials.weight && ( */}
              {userProfile.weight && (
              <Fragment>
                <FitnessCenterIcon color="primary" />{" "}
                {/* <span>{parseInt(credentials.weight)} lbs</span> */}
                <span>{parseInt(userProfile.weight)} lbs</span>
                <hr />
              </Fragment>
            )}
            {/* {credentials.age && ( */}
              {userProfile.age && (
              <Fragment>
                <CakeIcon color="primary" />{" "}
                {/* <span>{parseInt(credentials.age)} years old</span> */}
                <span>{parseInt(userProfile.age)} years old</span>
                <hr />
              </Fragment>
            )}
            <CalendarToday color="primary" />{" "}
            <span>
              {/* Joined {dayjs(credentials.createdAt).format("MMM YYYY")} */}
              Joined {dayjs(userProfile.createdAt).format("MMM YYYY")}
            </span>
          </div>
          <Link to="/login" variant="body2">
            <MyButton tip="Logout" onClick={this.handleLogout}>
              <KeyboardReturn color="primary" />
            </MyButton>
          </Link>
          <EditDetails />
        </div>
      </Paper>
    ) : (
      <Paper className={classes.paper}>
        <div className={classes.profile}>
          <div className="image-wrapper">
            <img
              // src={profile.imageUrl}
              src={currentProfile.user.imageUrl}
              alt="profile"
              className="profile-image"
            />
          </div>
          <hr />
          <div className="profile-details">
            <MuiLink
              component={Link}
              // to={`/users/${profile.handle}`}
              to={`/users/${currentProfile.user.handle}`}
              color="primary"
              variant="h5"
            >
              {/* @{profile.handle} */}
              @{currentProfile.user.handle}
            </MuiLink>
            <hr />
            {/* {profile.height && ( */}
              {currentProfile.user.height && (
              <Fragment>
                <AccessibilityNewIcon color="primary" />{" "}
                <span>
                  {/* {parseInt(profile.height / 12)}'{" "}
                  {parseInt(profile.height % 12)}" */}
                  {parseInt(currentProfile.user.height / 12)}'{" "}
                  {parseInt(currentProfile.user.height % 12)}"
                </span>
                <hr />
              </Fragment>
            )}
            <hr />
            {/* {profile.weight && ( */}
              {currentProfile.user.weight && (
              <Fragment>
                <FitnessCenterIcon color="primary" />{" "}
                {/* <span>{parseInt(profile.weight)} lbs</span> */}
                <span>{parseInt(currentProfile.user.weight)} lbs</span>
                <hr />
              </Fragment>
            )}
            {/* {profile.age && ( */}
              {currentProfile.user.age && (
              <Fragment>
                <CakeIcon color="primary" />{" "}
                {/* <span>{parseInt(profile.age)} years old</span> */}
                <span>{parseInt(currentProfile.user.age)} years old</span>
                <hr />
              </Fragment>
            )}
            <Fragment>
              <CalendarToday color="primary" />{" "}
              {/* <span>Joined {dayjs(profile.createdAt).format("MMM YYYY")}</span> */}
              <span>Joined {dayjs(currentProfile.user.createdAt).format("MMM YYYY")}</span>
              <hr />
            </Fragment>
            <Fragment>
              <ToggleButton
                // value={this.state.follow}
                // selected={this.state.follow}
                value={following.indexOf(currentProfile.user.handle) !== -1}
                selected={following.indexOf(currentProfile.user.handle) !== -1}
                onChange={this.handleFollow}
              >
                {following.indexOf(currentProfile.user.handle) === -1 ? "Follow" : "Following"}
              </ToggleButton>
            </Fragment>
          </div>
        </div>
      </Paper>
    );

    return profileMarkup;
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  data: state.data,  
  UI: state.UI,
});

const mapActionsToProps = { logoutUser, uploadImage, followUser, unfollowUser};

Profile.propTypes = {
  // profile: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  logoutUser: PropTypes.func.isRequired,
  uploadImage: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  UI: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  followUser: PropTypes.func.isRequired,
  unfollowUser: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(withStyles(styles)(Profile));
